/** @jsx jsx */
import React, { useEffect } from 'react';
import { jsx, css } from '@emotion/core';
import BlockUI from 'components/molecules/BlockUi';
import { logout } from 'api/login';
import Amplify, { Auth } from 'aws-amplify';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FlexBox from 'components/atoms/FlexBox';
import Button from "components/atoms/Button";

const style={
  wrapper: css({   
    width: "100%",
    minHeight: "100vh",
    margin: "0px auto",
    backgroundImage: "url(/login-back-e6ac60b256d2f031c73e8613933e2e8e3e3c8988062d2c05ec8d76bfe535a8ce.svg)",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    position: "relative",
    backgroundSize: "cover",
    overflowX: "hidden",
    minWidth: "320px",
    height: "100%",
  }),
  center: css({
    top:"50%",
    minWidth:"350px",
    width: "100%",
    position: "absolute",
    left: "0%",
    height: "20rem",
    marginTop: "-15rem"
  }),
  textCenter: css({
    textAlign: "center",
    color:"#007BC3",
    fontSize: "15px"
  }),
  paddingTop3: css({
    paddingTop:'3rem'
  }),
  paddingTop1: css({
    paddingTop:'1rem'
  }),
  paddingTop15: css({
    paddingTop:'1.5rem',
  })
}

const ExpiredPage: React.FC = () => {
  useEffect(() => {
    document.body.style.overflowY = 'scroll'
    return () => {
      document.body.style.overflowY = 'null';
    }
  }, [])
  return (
    <div css={style.wrapper}>
      <FlexBox customStyle={css(style.center)} alignItems="center"
        direction='column'
        justifyContent = 'center'> 
        <FlexBoxItem  customStyle={css({ marginTop: "-31px" })}>
          <h1 css={css({ margin: "0" })}>
            <img alt="Cydas" src="favicon.ico" css={css({ height: "48px" })}/>
          </h1>
        </FlexBoxItem>
        <FlexBoxItem customStyle={css(style.paddingTop15)}>
          <p css={style.textCenter}>セッションが切れました。タブを閉じてください。</p>  
        </FlexBoxItem>
      </FlexBox>
    </div>
  );
};

export default ExpiredPage;
